
<template>
  <div>
    <CRow  class="justify-content-md-center">
      <CCol sm="8">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> ニュース管理
            </CCardHeader>
            <CCardBody>
              <CCol md="12" class="">
                  <label class="record-label pt-3">タイトル</label>
                  <CInput placeholder="ニュースのタイトルを入力してください" :class="{ 'is-invalid': $v.news.title.$error }" v-model.trim="$v.news.title.$model" />

                  <label class="record-label pt-3">内容</label>
                  <wysiwyg  v-model.trim="$v.news.description.$model"  :class="{ 'is-invalid': $v.news.description.$error }"/>

                  <center>
                    <CButton v-if="isEdit == false" color="info" class="mt-4"  @click="createJob">作成</CButton>
                    <CButton v-else color="info" class="mt-4"  @click="updateJob">更新</CButton>
                  </center>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/vue"></script>
<script>
import axios from 'axios';
import moment from 'moment';
import { required, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      recordModal: false,
      deleteModal: false,
      news: {
        title: "",
        description: "",
      },
      images: {},
      record_id: this.$route.params.id,
      isEdit: false,
      application_start_datetime: "",
      application_end_datetime: "",
      industryTypes: {},
      isVisible: false,
      preview:'',
    }
  },
  validations: {
    news: {
      title: {required, minLength: minLength(4)},
      description: {required},
    },
  },
  methods: {
    formatData: function(label, d) {
        if(label == "name") {
          return this.record.name
        }
        if(label == "status") {
          return this.states[d]
        }
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    updateJob: function() {
      var im_d = ""
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/news/" + this.news.id, {"news": this.news}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          //this.$noty.success("更新されました")
          this.$router.push("/news");

        }).catch(error => {
          console.log(error)
        })
    },
    createJob: function() {

      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log("error")
      } else {
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/news", {"news": this.news}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.$router.push("/news");
          }).catch(error => {
            console.log(error)
          })
      }
    }
  },
  mounted() {
    if(this.record_id != undefined) {
      this.isEdit = true
      axios
        .get(process.env.VUE_APP_API_ENDPOINT +  "/news/" + this.record_id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then((res) => {
          this.news = res.data
        }).catch(error => {
          console.log(error)
        })
    }
    const items = [].slice.call(document.querySelectorAll('.editr--toolbar .dashboard form'));
      items.forEach(function (item, idx) {
        item.addEventListener('click', function(e) {
         e.target.focus()
        }.bind(this))
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industryTypes = [{
              value: "",
              label: "",
          }]
          response.data.industries.forEach((i) => {
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          console.log(error)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },

}
</script>
<style scoped lang="scss">

/deep/ .id_image {

}
.image {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-weight: 400;
    line-height: 1.5;
    border: 1px solid;
    border-radius: .25rem;
    color: #768192;
    background-color: #fff;
    border-color: #d8dbe0;
}
.w-60 {
    width: 60%;
}
.w-100 {
    width: 100%;
}
.is-invalid {
    border-color: red;
    input.form-control {
        border-color: red;
    }
}

.commonStyle{ padding:30px; text-align:center; margin:10px 0px; width:100%;}

.button{border:1px solid green; padding:3px; border-radius:5px; background-color:white;}
.commonStyle {
  p {
    margin: 0px;
  }
  .button p {color:green; margin: 5px 10px;}
}

</style>
